import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/landing';
export function PainSection() {
  return <section className="w-full bg-cream px-4 py-11 sm:px-8 sm:py-16 lg:py-20" data-id="element-114" data-mp="38wlvkxicj0ju">
      <div className="mx-auto max-w-6xl" data-id="element-115" data-mp="2uyx6tel5r99i">
        <h2 className="max-w-3xl font-display text-2xl font-extrabold leading-tight text-ink-900 sm:text-4xl" data-id="element-116" data-mp="2v08brhqcan27">
          Si alguna vez te pasó esto, este Mega Pack fue creado para vos.
        </h2>

        <ul className="mt-6 grid grid-cols-1 gap-2.5 sm:mt-8 sm:grid-cols-2 sm:gap-3" data-id="element-117" data-mp="2l69cqrlkbjeh">
          {painPoints.map(point => <li key={point} className="flex items-start gap-2.5 rounded-xl border border-cream-300 bg-white px-3.5 py-3 font-sans text-sm leading-snug text-ink-700 sm:text-base" data-id="element-118" data-mp="2bag2xfz8a40e">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick" aria-hidden="true" data-id="element-119" data-mp="229848wssv15s" />
              <span data-id="element-120" data-mp="2781gyn09io4w">{point}</span>
            </li>)}
        </ul>

        <p className="mt-7 max-w-3xl font-display text-xl font-extrabold leading-snug text-ink-900 sm:mt-9 sm:text-3xl" data-id="element-121" data-mp="3rlzizgf1e7pg">
          El problema no es que no tengas ideas.
          <span className="block text-gold-600" data-id="element-122" data-mp="5fkfb0o7y04p">
            El problema es tener que empezar desde cero cada vez.
          </span>
        </p>
      </div>
    </section>;
}